import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["value"]
const _hoisted_2 = { class: "hidden md:flex w-20" }
const _hoisted_3 = { class: "flex flex-row flex-1" }
const _hoisted_4 = { class: "w-full md:text-left md:w-1/6" }
const _hoisted_5 = { class: "text-headings-gray md:hidden mb-2" }
const _hoisted_6 = { class: "mb-2" }
const _hoisted_7 = { class: "w-full flex flex-row justify-between mb-5 md:hidden" }
const _hoisted_8 = { class: "flex flex-col md:w-1/2" }
const _hoisted_9 = { class: "text-headings-gray mb-2" }
const _hoisted_10 = ["src", "alt"]
const _hoisted_11 = { class: "flex flex-col md:w-1/2" }
const _hoisted_12 = { class: "text-headings-gray mb-2" }
const _hoisted_13 = { class: "hidden md:flex flex-col md:align-middle md:w-1/6" }
const _hoisted_14 = ["src", "alt", "v-if"]
const _hoisted_15 = { class: "hidden md:flex flex-col md:align-middle md:w-1/6" }
const _hoisted_16 = { class: "md:m-auto" }
const _hoisted_17 = { class: "w-full flex flex-col md:w-1/6 md:flex-row" }
const _hoisted_18 = { class: "h-8 m-auto px-3 md:text-light font-semibold capitalize bg-gray-300 rounded-full leading-8" }
const _hoisted_19 = { class: "w-full flex flex-col md:w-1/6 md:flex-row" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-place text-big mr-2" }, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-place text-big mr-2" }, null, -1)
const _hoisted_22 = { class: "w-full flex flex-col md:w-1/6 md:flex-row" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-place text-big mr-2" }, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-place text-big mr-2" }, null, -1)
const _hoisted_25 = { class: "w-full flex flex-col md:w-1/6 md:flex-row" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-label text-big mr-2" }, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-label text-big mr-2" }, null, -1)
const _hoisted_28 = { class: "hidden md:flex flex-row justify-end w-20" }
const _hoisted_29 = ["checked"]
const _hoisted_30 = { key: 0 }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "block w-full bg-gray-200 h-0.5 my-4" }, null, -1)
const _hoisted_32 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_33 = { class: "flex flex-row" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "hidden lg:flex lg:flex-col lg:w-20" }, null, -1)
const _hoisted_35 = { class: "mb-5 mr-10 min-w-1/8" }
const _hoisted_36 = { class: "text-headings-gray font-bold my-auto" }
const _hoisted_37 = ["innerHTML"]
const _hoisted_38 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_39 = { class: "text-headings-gray font-bold my-auto" }
const _hoisted_40 = ["innerHTML"]
const _hoisted_41 = ["innerHTML"]
const _hoisted_42 = ["innerHTML"]
const _hoisted_43 = ["innerHTML"]
const _hoisted_44 = ["innerHTML"]
const _hoisted_45 = ["innerHTML"]
const _hoisted_46 = ["innerHTML"]
const _hoisted_47 = ["innerHTML"]
const _hoisted_48 = ["innerHTML"]
const _hoisted_49 = ["innerHTML"]
const _hoisted_50 = {
  key: 0,
  class: "flex mr-10 flex-col min-w-1/8"
}
const _hoisted_51 = { class: "flex flex-row w-full justify-between mb-2" }
const _hoisted_52 = { class: "text-headings-gray font-bold mr-5" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_54 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_55 = ["innerHTML"]
const _hoisted_56 = ["innerHTML"]
const _hoisted_57 = ["innerHTML"]
const _hoisted_58 = ["innerHTML"]
const _hoisted_59 = ["innerHTML"]
const _hoisted_60 = ["innerHTML"]
const _hoisted_61 = ["innerHTML"]
const _hoisted_62 = ["innerHTML"]
const _hoisted_63 = ["innerHTML"]
const _hoisted_64 = ["innerHTML"]
const _hoisted_65 = { class: "flex mr-10 flex-col min-w-1/8" }
const _hoisted_66 = { class: "flex flex-row w-full justify-between mb-2" }
const _hoisted_67 = { class: "text-headings-gray font-bold mr-5" }
const _hoisted_68 = { class: "flex flex-row w-full justify-between mb-2" }
const _hoisted_69 = { class: "text-headings-gray font-bold mr-5" }
const _hoisted_70 = { class: "flex flex-row w-full justify-between mb-2" }
const _hoisted_71 = { class: "text-headings-gray font-bold mr-5" }
const _hoisted_72 = { class: "flex flex-row w-full justify-between mb-2" }
const _hoisted_73 = { class: "text-headings-gray font-bold mr-5" }
const _hoisted_74 = { class: "flex flex-row w-full justify-between mb-2" }
const _hoisted_75 = { class: "text-headings-gray font-bold mr-5" }
const _hoisted_76 = { class: "flex flex-row w-full justify-between mb-2" }
const _hoisted_77 = { class: "text-headings-gray font-bold mr-5" }
const _hoisted_78 = { class: "flex mr-10 flex-col min-w-1/8" }
const _hoisted_79 = { class: "flex flex-row w-full justify-between mb-2" }
const _hoisted_80 = { class: "text-headings-gray font-bold mr-5" }
const _hoisted_81 = { class: "flex flex-row w-full justify-between mb-2" }
const _hoisted_82 = { class: "text-headings-gray font-bold mr-5" }
const _hoisted_83 = { class: "flex flex-row w-full justify-between mb-2" }
const _hoisted_84 = { class: "text-headings-gray font-bold mr-5" }
const _hoisted_85 = { class: "flex flex-row w-full justify-between mb-2" }
const _hoisted_86 = { class: "text-headings-gray font-bold mr-5" }
const _hoisted_87 = { class: "flex flex-row w-full justify-between mb-2" }
const _hoisted_88 = { class: "text-headings-gray font-bold mr-5" }
const _hoisted_89 = { class: "flex flex-row w-full justify-between mb-2" }
const _hoisted_90 = { class: "text-headings-gray font-bold mr-5" }
const _hoisted_91 = { class: "capitalize" }
const _hoisted_92 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_93 = /*#__PURE__*/_createElementVNode("div", { class: "block w-full bg-gray-200 h-0.5 my-4" }, null, -1)
const _hoisted_94 = { class: "flex flex-row justify-end" }
const _hoisted_95 = { class: "md:w-1/8 md:flex-row" }
const _hoisted_96 = { class: "md:w-1/8 md:flex-row" }
const _hoisted_97 = {
  key: 1,
  class: "flex flex-col"
}
const _hoisted_98 = /*#__PURE__*/_createElementVNode("div", { class: "block w-full bg-gray-200 h-0.5 my-4" }, null, -1)
const _hoisted_99 = { class: "flex flex-row" }
const _hoisted_100 = /*#__PURE__*/_createElementVNode("div", { class: "hidden lg:flex lg:flex-col lg:w-20" }, null, -1)
const _hoisted_101 = { class: "flex w-1/2 pt-3" }
const _hoisted_102 = { class: "flex w-1/2 justify-end" }
const _hoisted_103 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-return ml-2" }, null, -1)
const _hoisted_104 = {
  key: 1,
  class: "flex flex-row mb-2"
}
const _hoisted_105 = /*#__PURE__*/_createElementVNode("p", { class: "hidden lg:flex lg:flex-col lg:w-20" }, null, -1)
const _hoisted_106 = { class: "flex flex-row flex-1" }
const _hoisted_107 = { class: "w-1/12 font-bold" }
const _hoisted_108 = ["innerHTML"]
const _hoisted_109 = { class: "w-1/6" }
const _hoisted_110 = /*#__PURE__*/_createElementVNode("span", { class: "icon-edit text-medium" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_expand_button = _resolveComponent("expand-button")!
  const _component_default_button = _resolveComponent("default-button")!
  const _component_parcel_details = _resolveComponent("parcel-details")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "flex flex-col justify-center bg-white text-light text-black rounded p-5 cursor-pointer text-justify relative mb-2 md:px-10",
      onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.isExpanded = !_ctx.isExpanded))
    }, [
      _createElementVNode("input", {
        type: "checkbox",
        class: "absolute top-6 right-6 md:hidden",
        value: _ctx.isChecked,
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('checkParcel', _ctx.parcel?.id)), ["stop"]))
      }, null, 8, _hoisted_1),
      _createElementVNode("div", {
        class: "flex flex-col md:flex-row md:text-center md:align-middle justify-center md:justify-between",
        onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.isExpanded = !_ctx.isExpanded))
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_expand_button, {
            class: "my-auto",
            modelValue: _ctx.isExpanded,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isExpanded) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("strong", _hoisted_5, _toDisplayString(_ctx.$t("parcels.list.item.labels.id")), 1),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", {
                class: "text-primary-blue font-bold mb-2",
                onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (
                _ctx.valid ? (_ctx.showDetails = true) : (_ctx.isExpanded = !_ctx.isExpanded)
              ), ["stop"]))
              }, _toDisplayString(_ctx.$t("parcels.list.item.parcel_id", { id: _ctx.parcel.id })), 1)
            ]),
            _createElementVNode("div", {
              class: "text-primary-blue font-bold mb-2 truncate",
              onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.openTrackingUrl(_ctx.parcel.tracking_url)), ["stop"]))
            }, _toDisplayString(_ctx.parcel.tracking_number), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("strong", _hoisted_9, _toDisplayString(_ctx.$t("parcels.list.item.labels.supplier")), 1),
              _createElementVNode("img", {
                src: _ctx.importImage(_ctx.parcel.supplier.full_name_standard),
                alt: _ctx.parcel ? _ctx.parcel.supplier.full_name_standard : ''
              }, null, 8, _hoisted_10)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("strong", _hoisted_12, _toDisplayString(_ctx.$t("parcels.list.item.labels.created_at")), 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.moment(_ctx.parcel.created_at, "YYYY-MM-DD HH:mm").format(
                  "DD.MM.YYYY"
                )), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("img", {
              class: "m-auto",
              style: _normalizeStyle([[
              _ctx.parcel.test_mode ? { filter: 'brightness(80%)' } : {},
            ], {"max-height":"50px"}]),
              src: _ctx.importImage(_ctx.parcel.supplier.full_name_standard),
              alt: _ctx.parcel ? _ctx.parcel.supplier.full_name_standard : '',
              "v-if": _ctx.parcel
            }, null, 12, _hoisted_14)
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.moment(_ctx.parcel.created_at, "YYYY-MM-DD HH:mm").format(
                "DD.MM.YYYY HH:mm"
              )), 1)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.valid ? _ctx.parcelStatus : _ctx.$t("general.failed")), 1)
          ]),
          _createElementVNode("div", _hoisted_19, [
            (_ctx.parcel.tracking_url)
              ? (_openBlock(), _createBlock(_component_default_button, {
                  key: 0,
                  type: "outline",
                  class: "md:hidden",
                  onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.openTrackingUrl(_ctx.parcel.tracking_url)), ["prevent"]))
                }, {
                  default: _withCtx(() => [
                    _hoisted_20,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("parcels.list.item.buttons.tracking")), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.parcel.tracking_url)
              ? (_openBlock(), _createBlock(_component_default_button, {
                  key: 1,
                  type: "empty",
                  class: "hidden md:flex md:m-auto",
                  onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.openTrackingUrl(_ctx.parcel.tracking_url)), ["prevent"]))
                }, {
                  default: _withCtx(() => [
                    _hoisted_21,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("parcels.list.item.buttons.tracking")), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_22, [
            (_ctx.parcel.final_mile_tracking_url)
              ? (_openBlock(), _createBlock(_component_default_button, {
                  key: 0,
                  type: "outline",
                  class: "md:hidden",
                  onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.openTrackingUrl(_ctx.parcel.final_mile_tracking_url)), ["prevent"]))
                }, {
                  default: _withCtx(() => [
                    _hoisted_23,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("parcels.list.item.buttons.fm_tracking")), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.parcel.final_mile_tracking_url)
              ? (_openBlock(), _createBlock(_component_default_button, {
                  key: 1,
                  type: "empty",
                  class: "hidden md:flex md:m-auto",
                  onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.openTrackingUrl(_ctx.parcel.final_mile_tracking_url)), ["prevent"]))
                }, {
                  default: _withCtx(() => [
                    _hoisted_24,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("parcels.list.item.buttons.fm_tracking")), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_25, [
            (_ctx.parcel.is_label_attached)
              ? (_openBlock(), _createBlock(_component_default_button, {
                  key: 0,
                  type: "outline",
                  class: "mb-2 md:hidden",
                  onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.downloadService.getLabel(_ctx.parcel.id.toString())), ["prevent"])),
                  "is-loading": _ctx.isDownloading
                }, {
                  default: _withCtx(() => [
                    _hoisted_26,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("parcels.list.item.buttons.label")), 1)
                  ]),
                  _: 1
                }, 8, ["is-loading"]))
              : _createCommentVNode("", true),
            (_ctx.parcel.is_label_attached)
              ? (_openBlock(), _createBlock(_component_default_button, {
                  key: 1,
                  type: "empty",
                  class: "mb-2 hidden md:flex md:m-auto",
                  onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (_ctx.downloadService.getLabel(_ctx.parcel.id.toString())), ["prevent"])),
                  "is-loading": _ctx.isDownloading
                }, {
                  default: _withCtx(() => [
                    _hoisted_27,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("parcels.list.item.buttons.label")), 1)
                  ]),
                  _: 1
                }, 8, ["is-loading"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("input", {
            type: "checkbox",
            checked: _ctx.isChecked,
            onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('checkParcel', _ctx.parcel?.id)))
          }, null, 40, _hoisted_29)
        ])
      ]),
      (_ctx.isExpanded)
        ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
            _hoisted_31,
            (_ctx.valid)
              ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _hoisted_34,
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("p", _hoisted_36, _toDisplayString(_ctx.$t("parcels.list.item.sender")), 1),
                      (_ctx.parcel?.shipper_address?.company_name)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: "mb-1",
                            innerHTML: `${_ctx.parcel?.shipper_address?.company_name}<br />`
                          }, null, 8, _hoisted_37))
                        : _createCommentVNode("", true),
                      _hoisted_38,
                      _createElementVNode("div", null, [
                        _createElementVNode("p", _hoisted_39, _toDisplayString(_ctx.$t("parcels.list.item.address")), 1),
                        (_ctx.parcel?.receiver_address?.company_name)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              class: "mb-1",
                              innerHTML: `${_ctx.parcel?.receiver_address?.company_name}<br />`
                            }, null, 8, _hoisted_40))
                          : _createCommentVNode("", true),
                        (_ctx.parcel?.receiver_address?.name)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 1,
                              class: "mb-1",
                              innerHTML: `${_ctx.parcel?.receiver_address?.name}<br />`
                            }, null, 8, _hoisted_41))
                          : _createCommentVNode("", true),
                        (_ctx.parcel?.receiver_address?.address_first_line)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 2,
                              class: "mb-1",
                              innerHTML: `${_ctx.parcel?.receiver_address?.address_first_line}<br />`
                            }, null, 8, _hoisted_42))
                          : _createCommentVNode("", true),
                        (_ctx.parcel?.receiver_address?.address_second_line)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 3,
                              class: "mb-1",
                              innerHTML: 
                  `${_ctx.parcel?.receiver_address?.address_second_line}<br />`
                
                            }, null, 8, _hoisted_43))
                          : _createCommentVNode("", true),
                        (_ctx.parcel?.receiver_address?.zip_code)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 4,
                              class: "mb-1",
                              innerHTML: `${_ctx.parcel?.receiver_address?.zip_code}<br /> `
                            }, null, 8, _hoisted_44))
                          : _createCommentVNode("", true),
                        (_ctx.parcel?.receiver_address?.city)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 5,
                              class: "mb-1",
                              innerHTML: `${_ctx.parcel?.receiver_address?.city} `
                            }, null, 8, _hoisted_45))
                          : _createCommentVNode("", true),
                        (_ctx.parcel?.receiver_address?.state)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 6,
                              class: "mb-1",
                              innerHTML: `${_ctx.parcel?.receiver_address?.state} `
                            }, null, 8, _hoisted_46))
                          : _createCommentVNode("", true),
                        (_ctx.parcel?.receiver_address?.country?.name)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 7,
                              class: "mb-1",
                              innerHTML: `${_ctx.parcel?.receiver_address?.country?.name} `
                            }, null, 8, _hoisted_47))
                          : _createCommentVNode("", true),
                        (_ctx.parcel?.receiver_address?.phone)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 8,
                              class: "mb-1",
                              innerHTML: `<br />${_ctx.parcel?.receiver_address?.phone}`
                            }, null, 8, _hoisted_48))
                          : _createCommentVNode("", true),
                        (_ctx.parcel?.receiver_address?.email)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 9,
                              class: "mb-1",
                              innerHTML: `<br />${_ctx.parcel?.receiver_address?.email} `
                            }, null, 8, _hoisted_49))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    (_ctx.pickup_point_available)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                          _createElementVNode("div", _hoisted_51, [
                            _createElementVNode("div", _hoisted_52, [
                              _createTextVNode(_toDisplayString(_ctx.$t("parcels.list.item.pickup_point")), 1),
                              _hoisted_53
                            ])
                          ]),
                          _createTextVNode(" Code: " + _toDisplayString(_ctx.parcel?.pickup_point_id || "-") + " ", 1),
                          _hoisted_54,
                          (_ctx.parcel?.pickup_point_address?.company_name)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: "mb-1",
                                innerHTML: `${_ctx.parcel?.pickup_point_address?.company_name}<br />`
                              }, null, 8, _hoisted_55))
                            : _createCommentVNode("", true),
                          (_ctx.parcel?.pickup_point_address?.name)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 1,
                                class: "mb-1",
                                innerHTML: `${_ctx.parcel?.pickup_point_address?.name}<br />`
                              }, null, 8, _hoisted_56))
                            : _createCommentVNode("", true),
                          (_ctx.parcel?.pickup_point_address?.address_first_line)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 2,
                                class: "mb-1",
                                innerHTML: 
                `${_ctx.parcel?.pickup_point_address?.address_first_line}<br />`
              
                              }, null, 8, _hoisted_57))
                            : _createCommentVNode("", true),
                          (_ctx.parcel?.pickup_point_address?.address_second_line)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 3,
                                class: "mb-1",
                                innerHTML: 
                `${_ctx.parcel?.pickup_point_address?.address_second_line}<br />`
              
                              }, null, 8, _hoisted_58))
                            : _createCommentVNode("", true),
                          (_ctx.parcel?.pickup_point_address?.zip_code)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 4,
                                class: "mb-1",
                                innerHTML: `${_ctx.parcel?.pickup_point_address?.zip_code}<br /> `
                              }, null, 8, _hoisted_59))
                            : _createCommentVNode("", true),
                          (_ctx.parcel?.pickup_point_address?.city)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 5,
                                class: "mb-1",
                                innerHTML: `${_ctx.parcel?.pickup_point_address?.city} `
                              }, null, 8, _hoisted_60))
                            : _createCommentVNode("", true),
                          (_ctx.parcel?.pickup_point_address?.state)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 6,
                                class: "mb-1",
                                innerHTML: `${_ctx.parcel?.pickup_point_address?.state} `
                              }, null, 8, _hoisted_61))
                            : _createCommentVNode("", true),
                          (_ctx.parcel?.pickup_point_address?.country?.name)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 7,
                                class: "mb-1",
                                innerHTML: `${_ctx.parcel?.pickup_point_address?.country?.name} `
                              }, null, 8, _hoisted_62))
                            : _createCommentVNode("", true),
                          (_ctx.parcel?.pickup_point_address?.phone)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 8,
                                class: "mb-1",
                                innerHTML: `<br />${_ctx.parcel?.pickup_point_address?.phone}`
                              }, null, 8, _hoisted_63))
                            : _createCommentVNode("", true),
                          (_ctx.parcel?.pickup_point_address?.email)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 9,
                                class: "mb-1",
                                innerHTML: `<br />${_ctx.parcel?.pickup_point_address?.email} `
                              }, null, 8, _hoisted_64))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_65, [
                      _createElementVNode("div", _hoisted_66, [
                        _createElementVNode("div", _hoisted_67, _toDisplayString(_ctx.$t("parcels.list.item.weight")), 1),
                        _createElementVNode("div", null, _toDisplayString(_ctx.$t("parcels.details.weight_value", {
                    weight: _ctx.parcel?.weight || "-",
                  })), 1)
                      ]),
                      _createElementVNode("div", _hoisted_68, [
                        _createElementVNode("div", _hoisted_69, _toDisplayString(_ctx.$t("parcels.list.item.scanned_weight")), 1),
                        _createElementVNode("div", null, _toDisplayString(_ctx.$t("parcels.details.weight_value", {
                    weight: _ctx.parcel?.scanned_weight || "-",
                  })), 1)
                      ]),
                      _createElementVNode("div", _hoisted_70, [
                        _createElementVNode("div", _hoisted_71, _toDisplayString(_ctx.$t("parcels.list.item.currency")), 1),
                        _createElementVNode("div", null, _toDisplayString(_ctx.parcel.price_currency || "-"), 1)
                      ]),
                      _createElementVNode("div", _hoisted_72, [
                        _createElementVNode("div", _hoisted_73, _toDisplayString(_ctx.$t("parcels.list.item.shipper_reference")), 1),
                        _createElementVNode("div", null, _toDisplayString(_ctx.parcel.shipper_reference || "-"), 1)
                      ]),
                      _createElementVNode("div", _hoisted_74, [
                        _createElementVNode("div", _hoisted_75, _toDisplayString(_ctx.$t("parcels.list.item.final_mile_tracking_number")), 1),
                        _createElementVNode("div", null, _toDisplayString(_ctx.parcel.final_mile_tracking_number || "-"), 1)
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parcel.references, (item) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: item.key
                        }, [
                          _createElementVNode("div", _hoisted_76, [
                            _createElementVNode("div", _hoisted_77, _toDisplayString(item.key), 1),
                            _createElementVNode("div", null, _toDisplayString(item.value || "-"), 1)
                          ])
                        ]))
                      }), 128))
                    ]),
                    _createElementVNode("div", _hoisted_78, [
                      _createElementVNode("div", _hoisted_79, [
                        _createElementVNode("div", _hoisted_80, _toDisplayString(_ctx.$t("general.created")), 1),
                        _createElementVNode("div", null, _toDisplayString(_ctx.moment(_ctx.parcel.created_at, "YYYY-MM-DD HH:mm").format(
                    "DD.MM.YYYY HH:mm"
                  )), 1)
                      ]),
                      _createElementVNode("div", _hoisted_81, [
                        _createElementVNode("div", _hoisted_82, _toDisplayString(_ctx.$t("general.accepted")), 1),
                        _createElementVNode("div", null, _toDisplayString(_ctx.parcel.accepted_at
                    ? _ctx.moment(_ctx.parcel.accepted_at, "YYYY-MM-DD HH:mm").format(
                        "DD.MM.YYYY HH:mm"
                      )
                    : "-"), 1)
                      ]),
                      _createElementVNode("div", _hoisted_83, [
                        _createElementVNode("div", _hoisted_84, _toDisplayString(_ctx.$t("general.in_transit")), 1),
                        _createElementVNode("div", null, _toDisplayString(_ctx.parcel.sent_to_transit_at
                    ? _ctx.moment(
                        _ctx.parcel.sent_to_transit_at,
                        "YYYY-MM-DD HH:mm"
                      ).format("DD.MM.YYYY HH:mm")
                    : "-"), 1)
                      ]),
                      _createElementVNode("div", _hoisted_85, [
                        _createElementVNode("div", _hoisted_86, _toDisplayString(_ctx.$t("general.returned")), 1),
                        _createElementVNode("div", null, _toDisplayString(_ctx.parcel.returned_to_customer_at
                    ? _ctx.moment(
                        _ctx.parcel?.returned_to_customer_at,
                        "YYYY-MM-DD HH:mm"
                      ).format("DD.MM.YYYY HH:mm")
                    : "-"), 1)
                      ]),
                      _createElementVNode("div", _hoisted_87, [
                        _createElementVNode("div", _hoisted_88, _toDisplayString(_ctx.$t("general.delivered")), 1),
                        _createElementVNode("div", null, _toDisplayString(_ctx.parcel.delivered_at
                    ? _ctx.moment(_ctx.parcel.delivered_at, "YYYY-MM-DD HH:mm").format(
                        "DD.MM.YYYY HH:mm"
                      )
                    : "-"), 1)
                      ]),
                      _createElementVNode("div", _hoisted_89, [
                        _createElementVNode("div", _hoisted_90, _toDisplayString(_ctx.$t("general.test_mode")), 1),
                        _createElementVNode("div", _hoisted_91, _toDisplayString(_ctx.parcel.test_mode), 1)
                      ])
                    ])
                  ]),
                  (
            _ctx.parcel.status === _ctx.ParcelStatus.CREATED && !_ctx.parcel?.return_parcel?.id
          )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
                        _hoisted_93,
                        _createElementVNode("div", _hoisted_94, [
                          _createElementVNode("div", _hoisted_95, [
                            _createVNode(_component_default_button, {
                              class: "flex-col",
                              type: "outline",
                              onClick: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (_ctx.openIncindentUrl(_ctx.parcel, _ctx.accountDetails)), ["prevent"]))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("return_parcels.list.actions.open_incident")), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_96, [
                            _createVNode(_component_default_button, {
                              class: "flex-col",
                              type: "outline",
                              onClick: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (this.$emit('createReturnParcel', _ctx.parcel)), ["prevent","stop"]))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("return_parcels.list.actions.return_parcel")), 1)
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.parcel?.return_parcel?.id)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_97, [
                        _hoisted_98,
                        _createElementVNode("div", _hoisted_99, [
                          _hoisted_100,
                          _createElementVNode("div", _hoisted_101, [
                            _createElementVNode("p", null, _toDisplayString(_ctx.$t("parcels.list.item.return_created_at", {
                    created_at: _ctx.moment(
                      _ctx.parcel.return_parcel.created_at,
                      "YYYY-MM-DD HH:mm"
                    ).format("DD.MM.YYYY HH:mm"),
                  })), 1)
                          ]),
                          _createElementVNode("div", _hoisted_102, [
                            _createVNode(_component_default_button, {
                              class: "w-full md:w-auto",
                              type: "empty",
                              onClick: _cache[14] || (_cache[14] = _withModifiers(($event: any) => (
                  _ctx.$router.push({
                    name: 'return_parcels.list',
                    query: {
                      search: `${_ctx.parcel.return_parcel.id}`,
                    },
                  })
                ), ["prevent","stop"]))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("return_parcels.list.actions.check_return")) + " ", 1),
                                _hoisted_103
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (!_ctx.valid)
              ? (_openBlock(), _createElementBlock("div", _hoisted_104, [
                  _hoisted_105,
                  _createElementVNode("div", _hoisted_106, [
                    _createElementVNode("p", _hoisted_107, _toDisplayString(_ctx.$t("bulk_parcels.errors.item.details.description")), 1),
                    _createElementVNode("p", {
                      class: "w-3/4",
                      innerHTML: _ctx.prepareErrors(_ctx.parcel.validation_errors)
                    }, null, 8, _hoisted_108),
                    _createElementVNode("div", _hoisted_109, [
                      _createElementVNode("p", {
                        class: "text-right text-primary-blue font-bold",
                        onClick: _cache[15] || (_cache[15] = _withModifiers(($event: any) => (this.$emit('editParcel', _ctx.parcel.id)), ["stop"]))
                      }, [
                        _createTextVNode(_toDisplayString(_ctx.$t("parcels.edit.title")) + " ", 1),
                        _hoisted_110
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_modal, {
      modelValue: _ctx.showDetails,
      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.showDetails) = $event)),
      "hide-buttons": true
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("parcels.list.item.parcel_id", { id: _ctx.parcel.id })), 1)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_parcel_details, {
          "parcel-id": _ctx.parcel.id
        }, null, 8, ["parcel-id"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}